import request from 'superagent';
import _ from 'lodash';
import fieldNames from '../../Integrations/connections/FilenameTemplate/filenameTemplateFields';
import { notify } from '../../components/common/Notification';

export const actionTypes = {
  REQUEST_CONNECTION: 'REQUEST_CONNECTION',
  RECEIVE_CONNECTION: 'RECEIVE_CONNECTION',
  REQUEST_DISCONNECTION: 'REQUEST_DISCONNECTION',
  RECEIVE_DISCONNECTION: 'RECEIVE_DISCONNECTION',
  REQUEST_CONNECTIONS: 'REQUEST_CONNECTIONS',
  RECEIVE_CONNECTIONS: 'RECEIVE_CONNECTIONS',
  UPDATE_CONNECTION: 'UPDATE_CONNECTION',
  SERVICE_ERROR: 'SERVICE_ERROR',
  UPDATE_AUTH: 'UPDATE_AUTH',
  UPDATE_PRICING: 'UPDATE_PRICING',
  REQUEST_FILENAME_TEMPLATE: 'REQUEST_FILENAME_TEMPLATE',
  RECEIVE_FILENAME_TEMPLATE: 'RECEIVE_FILENAME_TEMPLATE',
  FILENAME_TEMPLATE_ERROR: 'FILENAME_TEMPLATE_ERROR',
};

export const authenticate = params => (dispatch) => {
  window.Kloudless.authenticator(null, params, (auth) => {
    dispatch({
      type: actionTypes.UPDATE_AUTH,
      auth,
    });
  });

  return dispatch({ type: actionTypes.REQUEST_DISCONNECTION });
};

export const connectIntegration = (svcType, svcName, connectionDetails) => (dispatch) => {
  dispatch({ type: actionTypes.REQUEST_CONNECTION });

  function onFailure(errorMessage) {
    dispatch({
      type: actionTypes.RECEIVE_CONNECTION,
      results: errorMessage,
    });
  }

  function onSuccess(response) {
    if (response.status !== 201) {
      return onFailure(response.message || 'service error');
    }

    const connection = convertConnectionToRedux(response.body.integration);

    dispatch({
      type: actionTypes.RECEIVE_CONNECTION,
      results: [connection],
    });
  }

  return request
    .post('/rpc/integrations/connections')
    .send({
      integration_type: svcType,
      service: svcName,
      // for some services like calendar, there are no connection details
      ...(connectionDetails && { connection_details: connectionDetails }),
    })
    .then(onSuccess, onFailure);
};

export const disconnectIntegration = connectionId => (dispatch) => {
  dispatch({ type: actionTypes.REQUEST_DISCONNECTION });

  function onSuccess() {
    dispatch({
      type: actionTypes.RECEIVE_DISCONNECTION,
      connectionId,
    });
  }

  function onFailure(errorMessage) {
    dispatch({
      type: actionTypes.RECEIVE_DISCONNECTION,
      errorMessage,
    });
  }

  return request
    .delete(`/rpc/integrations/connections/${connectionId}`)
    .then(onSuccess, onFailure);
};

export const connections = () => (dispatch) => {
  dispatch({ type: actionTypes.REQUEST_CONNECTIONS });

  function onFailure(errorMessage) {
    dispatch({
      type: actionTypes.RECEIVE_CONNECTIONS,
      errorMessage,
    });
  }

  function onSuccess(response) {
    if (response.status !== 200) {
      return onFailure(response.message || 'service error');
    }

    const { integrations = [] } = response.body;
    const connections = integrations.map(connection => convertConnectionToRedux(connection));

    dispatch({
      type: actionTypes.RECEIVE_CONNECTIONS,
      results: connections,
    });

    dispatch({
      type: actionTypes.UPDATE_PRICING,
      agreedToPricing: (integrations.length > 0),
    });
  }

  return request
    .get('/rpc/integrations/connections')
    .then(onSuccess, onFailure);
};

export const updateFilenameTemplate = (connectionId, updates) => dispatch =>
  dispatch({
    type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
    updates,
    connectionId,
  });

export const updateConnection = (connectionId, updates) => dispatch => {
  dispatch({
    type: actionTypes.UPDATE_CONNECTION,
    updates: convertConnectionToRedux(updates),
    connectionId,
  });
};

function splitFilenameTemplateToArray(template) {
  const separators = fieldNames
    .filter(x => x.type === 'separator')
    .map(f => f.name).concat(['{', '}', '{{', '}}', '\\/']);

  const splitted = template.split(new RegExp('([' + separators.join('') + '])', 'g'));
  const filtered = splitted.filter(segment => segment !== '');
  // TODO - cleanup the code below
  // Low on sleep - this is horribly hacked together but I can't think of a better way for now
  const rejoined = filtered.reduce((accum, n, idx) => {
    if (idx === 0 || (separators.includes(n) && n !== '_')) {
      accum.push(n);
      return accum;
    }
    if (!separators.includes(n) || n === '_') {
      const prev = accum[accum.length - 1];
      // if previous is a separator char, make a new string
      // else append it to the existing string
      if (separators.includes(prev) || prev[prev.length - 1] === '}') {
        accum.push(n);
        return accum;
      } else {
        accum[accum.length - 1] = prev + n;
        return accum;
      }
    }
    return accum;
  }, []);

  return rejoined.filter(x => x !== '{' && x !== '}');
}

function parseFilenameTemplate(template) {
  if (!template) return;

  const filenameTemplateArray = splitFilenameTemplateToArray(template);
  console.log("MJS Split filename template ", filenameTemplateArray);

  const [folderPathFields, fileFormatFields] = splitFilenameTemplates(filenameTemplateArray);
  console.log("MJS folder path fields: ", folderPathFields);
  console.log("MJS file format fields: ", fileFormatFields);

  return { fileFormatFields, folderPathFields };
}

const convertFileNameSettingsToRedux = (filenameSettings) => {
  if (!filenameSettings)
    return null;

  const {
    created,
    date_format,
    description_max_words,
    filename_template,
    modified,
    root_folder,
  } = filenameSettings;

  // TODO seems nasty having this here.  Not sure if there's a better option.
  const initialFilenameTemplateState = {
    isVisible: false,
    isLoading: false,
    created: null,
    modified: null,
    selectedFolderPathFields: [],
    selectedFileFormatFields: [],
    savedRootFolder: '',
    savedFolderPathFields: [],
    savedFileFormatFields: [],
    selectedFields: [],
    savedFormatFields: [],
    errorMessage: null,
    date_format: 'YYYY-MM-DD',
    description_max_words: 6,
    root_folder: null,
  };

  const parsedTemplate = parseFilenameTemplate(filename_template);

  return {
    template: filename_template,
    dateFormat: filenameSettings.date_format,
    descMaxWords: filenameSettings.description_max_words,
    created,
    modified,
    filenameTemplate: {
      ...initialFilenameTemplateState,

      isVisible: true,

      selectedFileFormatFields: parsedTemplate.fileFormatFields,
      selectedFolderPathFields: parsedTemplate.folderPathFields,

      savedFileFormatFields: parsedTemplate.fileFormatFields,
      savedFolderPathFields: parsedTemplate.folderPathFields,

      created,
      modified,
      date_format,
      description_max_words,
      root_folder,
    },
  };
};

const convertConnectionToRedux = (connection) => {
  // services that use matter folders
  const matterFolderServices = ['imanage', 'netdocuments', 'clio', 'rocketmatter'];

  // services that have option to use an "app folder"
  const appFolderServices = ['dropbox','onedrive'];

  return {
    connectionId: connection.connection_id,
    integration_type: connection.integration_type,
    service: connection.service,
    sync_type: connection.sync_type,
    combine_pdfs: _.get(connection, 'file_settings.combine_pdfs', false),
    sync_from: new Date(connection.sync_from),
    sync_mode: _.get(connection, 'file_settings.sync_mode'),
    folder_config: _.get(connection, 'file_settings.folder_config', 'none'),
    hasMatterFolders: (matterFolderServices.indexOf(connection.service) !== -1),
    hasAppFolder: (appFolderServices.indexOf(connection.service) !== -1),
    filenameSettings: convertFileNameSettingsToRedux(connection.filename_settings),
  };
}

function warnNotConnected(dispatch) {
  notify.error(
    'Warning!  You must connect a service to update the filename templates',
    { position: 'top-center' },
  );
  // send empty contents to clear the loading spinner
  dispatch({
    type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
    results: {},
  });
}

function splitFilenameTemplates(fields) {
  const pathIdx = fields.lastIndexOf('/');
  // only filename?
  if (pathIdx === -1) return [ [], fields ];

  const foldPathFields = fields.slice(0, pathIdx + 1);
  const fileFormatFields = fields.slice(pathIdx + 1);
  return [foldPathFields, fileFormatFields];
}

export const getFilenameTemplates = id => (dispatch) => {
  function onSuccess(response) {
    const { created, modified, date_format, template = '', description_max_words = 6 } = response.body;

    const parsedTemplate = parseFilenameTemplate(template);

    dispatch({
      type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
      results: {
        isVisible: true,
        created,
        modified,
        date_format,
        selectedFileFormatFields: parsedTemplate.fileFormatFields,
        selectedFolderPathFields: parsedTemplate.folderPathFields,

        savedFileFormatFields: parsedTemplate.fileFormatFields,
        savedFolderPathFields: parsedTemplate.folderPathFields,

        // selectedFields: fields,
        // savedFormatFields: fields,
        description_max_words,
      },
    });
  }

  function onFailure(errorMessage) {
    if (errorMessage.status === 404) {
      return dispatch({
        type: actionTypes.RECEIVE_FILENAME_TEMPLATE,
        results: {},
      });
    }

    const msg = _.get(errorMessage, 'response.body.error', errorMessage);
    notify.error(`Error! ${msg}`, { position: 'top-center' });
    dispatch({
      type: actionTypes.FILENAME_TEMPLATE_ERROR,
      errorMessage: msg,
    });
  }

  return request
    .get(`/rpc/integrations/connections/${id}/filename_template`)
    .then(onSuccess, onFailure);
};

export const saveFilenameTemplates = ({
  id,
  template,
  date_format,
  description_max_words,
  root_folder,
}) => (dispatch) => {
  if (id == null) {
    warnNotConnected(dispatch);
    return;
  }

  dispatch({
    type: actionTypes.REQUEST_FILENAME_TEMPLATE,
  });

  function onSuccess(filenameResp) {
    notify.success('Success!  Filename Template Updated', { position: 'top-center' });

    const filenameTemplate = filenameResp.body.template;

    const { root_folder: newRootFolder } = filenameResp.body;

    const { fileFormatFields, folderPathFields } = parseFilenameTemplate(filenameTemplate);

    return updateFilenameTemplate(id, {
      savedFileFormatFields: fileFormatFields,
      savedFolderPathFields: folderPathFields,
      savedRootFolder: newRootFolder || '',
      root_folder: newRootFolder || '',
    })(dispatch);
  }

  function onFailure(errorMessage) {
    const msg = _.get(errorMessage, 'response.body.error', errorMessage);
    notify.error(`Error! ${msg}`, { position: 'top-center' });

    dispatch({
      type: actionTypes.FILENAME_TEMPLATE_ERROR,
      errorMessage: msg,
    });
  }

  const filenameTemplateReq = request
    .post(`/rpc/integrations/connections/${id}/filename_template`)
    .set('Accept', 'application/json')
    .send({ template, date_format, description_max_words, root_folder });

  return filenameTemplateReq.then(onSuccess, onFailure);
};

export const deleteFilenameTemplates = ({ id }) => (dispatch) => {
  if (id == null) {
    warnNotConnected(dispatch);
    return;
  }

  dispatch({
    type: actionTypes.REQUEST_FILENAME_TEMPLATE,
  });

  function onSuccess() {
    notify.success('Success!  Filename Template Updated', { position: 'top-center' });
    return updateFilenameTemplate(id, { savedFormatFields: [] })(dispatch);
  }

  function onFailure(errorMessage) {
    const msg = _.get(errorMessage, 'response.body.error', errorMessage);
    notify.error(`Error! ${msg}`, { position: 'top-center' });

    dispatch({
      type: actionTypes.FILENAME_TEMPLATE_ERROR,
      errorMessage: msg,
    });
  }

  return request
    .del(`/rpc/integrations/connections/${id}/filename_template`)
    .set('Accept', 'application/json')
    .then(onSuccess, onFailure);
};

// XXX this is clearly wrong
export const getConnections = () => (dispatch) => {
  return connections()(dispatch)
};



// WEBPACK FOOTER //
// ./src/redux/actions/integrationsConnectionActions.js